
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function Confirmation(props) {

    const doAction = () => {
        props.action()
        props.setOpen(false)
    }

    const rejectAction = () => {
        if (props.rejectAction) {
            props.rejectAction()
        }
        props.setOpen(false)
    }

    return (
        <Dialog open={props.open} onClose={props.setOpen.bind(this, false)}>
            <DialogTitle>
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={doAction.bind(this)}
                    autoFocus
                    variant='contained'
                >
                    {props.actionMsg}
                </Button>
                <Button onClick={rejectAction.bind(this)}>
                    {props.rejectMsg}
                </Button>
            </DialogActions>
        </Dialog>
    )

}